import { gql } from 'apollo-boost';

export const REVOKE_FOLDER_SHARE = gql`
    mutation revokeFolderShare($data: RevokeFolderShareInput!) {
        revokeFolderShare(data: $data)
    }
`;
